import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { FileUpload } from "../icons";

// Components
import UploadXML from "../UI/UploadXML";
import NavbarNavigation from "./NavbarNavigation";
import UserNavigation from "./UserNavigation";
import LanguageSwitcher from "../LanguageSwitcher";

//
import LogoApp1 from "../../images/logo-app-1.svg";

const Navbar = ({ setValidateClicked, showHighlight, setShowHighlight }) => {
  const { t } = useTranslation();
  const { isLoggedin } = useSelector((state) => state.user);

  return (
    <nav className="navbar navbar-expand-lg">
      <div className="container-nav">
        <h1 className="navbar-brand">
          <img src={LogoApp1} alt="Podcast XML Maker" />
        </h1>

        <div className="navbar-menus flex-grow-0" id="navbarNavDropdown">
          <LanguageSwitcher />
          {isLoggedin && <UserNavigation />}
          <NavbarNavigation
            setValidateClicked={setValidateClicked}
            showHighlight={showHighlight}
            setShowHighlight={setShowHighlight}
          />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
